export const CONSENT_STORAGE_KEY = 'tp_consent_v1';
export const CONSENT_CHANGE_EVENT = 'tp:consent-changed';

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return { ads: 'unknown', analytics: 'unknown', updatedAt: null };
    const parsed = JSON.parse(raw);
    return {
      ads: parsed?.ads || 'unknown',
      analytics: parsed?.analytics || 'unknown',
      updatedAt: parsed?.updatedAt || null,
    };
  } catch {
    return { ads: 'unknown', analytics: 'unknown', updatedAt: null };
  }
}

export function writeConsent(next) {
  try {
    const payload = {
      ads: next?.ads || 'unknown',
      analytics: next?.analytics || 'unknown',
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(payload));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: payload }));
    }
    return payload;
  } catch {
    return null;
  }
}
